module.exports = __webpack_public_path__ + "static/media/tilde.71ffa50e.svg";